module.exports = __webpack_public_path__ + "media/images/paper-clip-172d73b7.svg";